/** True when running inside Electron with preload `desktopV2Api` (not the web SPA stub). */
export function isElectronRuntime(): boolean {
  if (typeof window === "undefined") return false;
  const w = window as unknown as {
    desktopV2Api?: unknown;
    __JUSTWRITE_RUNTIME__?: "electron" | "web";
  };
  if (w.__JUSTWRITE_RUNTIME__ === "web") return false;
  if (w.__JUSTWRITE_RUNTIME__ === "electron") return true;
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  return /\bElectron\//.test(ua) && typeof w.desktopV2Api !== "undefined";
}

/** True when running as a browser SPA (app.heyjustwrite.com / Vite without Electron preload). */
export function isWebRuntime(): boolean {
  return !isElectronRuntime();
}

/** True when Premier is hosted inside the Tauri desktop-v3 shell. */
export function isTauriRuntime(): boolean {
  if (typeof window === "undefined") return false;
  const w = window as unknown as { __TAURI_INTERNALS__?: unknown; isTauri?: boolean };
  return Boolean(w.__TAURI_INTERNALS__) || w.isTauri === true;
}

/**
 * Premier SPA and Tauri desktop-v3: account is required and the database is primary.
 * Electron desktop-v2 stays file-primary.
 */
export function isAccountPrimaryRuntime(): boolean {
  return !isElectronRuntime();
}

const DEFAULT_API_BASE = "https://heyjustwrite.com";

/** Apex API origin for the web SPA (pairing, books, LLM proxy). */
export function getWebApiBaseUrl(): string {
  const fromEnv =
    typeof import.meta !== "undefined" &&
    typeof import.meta.env?.VITE_API_BASE_URL === "string"
      ? import.meta.env.VITE_API_BASE_URL.trim().replace(/\/+$/, "")
      : "";
  if (fromEnv) return fromEnv;
  if (typeof window !== "undefined" && window.location?.origin) {
    // Local Vite: prefer apex API; packaged SPA should set VITE_API_BASE_URL at build time.
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return DEFAULT_API_BASE;
    }
    if (host === "app.heyjustwrite.com") {
      return DEFAULT_API_BASE;
    }
  }
  return DEFAULT_API_BASE;
}
